<template>
  <TimeRange
    ref="timeRange"
    class="flex justify-between"
    :blocked-time-slots="blockedTimeSlots"
    :min-value="roomOpenHours[0]"
    :max-value="roomOpenHours[1]"
    :available-time-slots="roomOpenHours"
    :time-format="l10n.timeFormat"
    :input-classes="[
      'w-1/2 mr-2',
      'w-1/2 ml-2',
    ]"
    :model-value="modelValue"
    select-time-from-before-time-to
    blocked-time-slot-label="Booked"
    id-from="time_from"
    id-to="time_to"
    data-test-id-from="enquiry-form__time-from"
    data-test-id-to="enquiry-form__time-to"
    @update:modelValue="update"
    @selectClick="(field) => $emit('selectClick', field)"
  />
</template>

<script>
import TimeRange from '@/components/Ui/Forms/TimeRange.vue';
import {
  getBlockedTimeSlots,
  getMaximumSelectableToSlot,
  getRoomOpenHours,
} from '@/services/hours-map.js';

export default {
  name: 'TimeFields',
  emits: ['update:modelValue', 'selectClick'],
  components: { TimeRange },

  props: {
    modelValue: {
      type: Array,
      validator: value => value.length === 2,
    },
    date: {
      type: String,
      default: null,
    },
    room: {
      type: Object,
      required: true,
    },
    l10n: {
      type: Object,
      required: true,
    },
  },

  computed: {
    roomOpenHours() {
      return getRoomOpenHours(this.date, this.room.availability);
    },

    blockedTimeSlots() {
      return getBlockedTimeSlots(this.date, this.room.availability);
    },
  },

  methods: {
    update([from, to]) {
      const timeFrom = parseInt(from, 10);
      const timeTo = parseInt(to, 10);

      const isTimeFromChanged = timeFrom !== this.modelValue[0];

      let finalTimeTo = timeTo || this.modelValue[1];
      if (isTimeFromChanged) {
        finalTimeTo = Math.min(timeFrom + (this.room.minHoursForBooking * 2), this.roomOpenHours[1]);
      }
      finalTimeTo = Math.max(finalTimeTo, this.roomOpenHours[0] + 1, timeFrom + 1);
      finalTimeTo = Number.isNaN(finalTimeTo) ? null : finalTimeTo;

      const finalTimeFrom = Number.isNaN(timeFrom) ? null : timeFrom;

      // prevent setting time to if it hits a partial booking
      if (isTimeFromChanged) {
        finalTimeTo = getMaximumSelectableToSlot(this.roomOpenHours, this.blockedTimeSlots, finalTimeFrom, finalTimeTo);
      }
      this.$emit('update:modelValue', [finalTimeFrom, finalTimeTo], isTimeFromChanged ? 'time_from' : 'time_to');
    },
  },

  mounted() {
    const notOpenDuringSavedHours = this.modelValue[0] < this.roomOpenHours[0] || this.roomOpenHours[1] < this.modelValue[1];
    const bookedDuringSavedHours = this.blockedTimeSlots.find(([timeFrom, timeTo]) => {
      return (timeFrom <= this.modelValue[0] && this.modelValue[0] <= timeTo)
        || (timeFrom <= this.modelValue[1] && this.modelValue[1] <= timeTo)
        || (this.modelValue[0] <= timeFrom && timeTo <= this.modelValue[1]);
    });
    if (notOpenDuringSavedHours || bookedDuringSavedHours) {
      this.$emit('update:modelValue', [null, null], false);
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
